import { useApiErrorMessage } from '@/shared/hook';
import { PagePanel } from '@/shared/ui';
import { redirect } from '@/shared/util';

interface UserErrorProps {
  error: unknown;
}

export function UserError({ error }: UserErrorProps) {
  const message = useApiErrorMessage(error, 'USER.ERROR.DESCRIPTION');

  return (
    <PagePanel
      action="AUTHENTICATION.RETURN_TO_LOGIN"
      message="API.ERROR.MESSAGE"
      onActionClick={redirect.toLogin}
      title="USER.ERROR.TITLE"
      translationValue={{ message }}
      variant="warning"
    />
  );
}
